import React from "react"
import clsx from "clsx"
import { container, FlexBox, LoadingBox } from "@components/wrapper"

import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime"
import "dayjs/locale/id"
import { CareerCard } from "@components/card"
import { useScreenSize } from "@lib/hooks"
import { chunk } from "@lib/functions"
import { HARISENIN_PUBLIC_PAGE_ASSETS } from "@const/pictures"
import { flex_center } from "@constants/styles"
import { useJobs } from "@modules/career-list/context/JobsContext"
import { Job } from "@interfaces/career"
import Image from "next/image"

export function CareerColumn() {
  const { deviceType } = useScreenSize()
  dayjs.extend(relativeTime)

  const { isLoading, jobs } = useJobs()

  const chunked = chunk(jobs, 3) as Job[][]

  if (isLoading) {
    return (
      <section className={clsx(container, flex_center)}>
        <LoadingBox height="h-[30vh]" />
      </section>
    )
  }

  if (!chunked.length) {
    return (
      <section className={clsx(container, flex_center, "flex-col gap-5 sm:py-20 py-5")}>
        <Image
          src={`${HARISENIN_PUBLIC_PAGE_ASSETS}/risebinar_no-data.png`}
          alt="Empty event or workshop"
          className="sm:w-1/5 w-1/2"
          width={200}
          height={64}
        />
        <h3 className="font-semibold sm:text-lg">Tidak ada lowongan saat ini</h3>
      </section>
    )
  }

  if (deviceType !== "mobile") {
    return (
      <section className={clsx(container, "sm:grid sm:grid-cols-3 sm:gap-7", "pt-9")}>
        {jobs.map((career, i) => (
          <CareerCard career={career} key={i} />
        ))}
      </section>
    )
  } else {
    return (
      <section className="slider-mobile pl-4 pt-9">
        <div className="flex w-full gap-5">
          {chunked.map((careers, i) => (
            <FlexBox key={i} className="gap-5 pr-4">
              {careers.map((c: any, idx: number) => (
                <CareerCard career={c} key={idx} customWidth="w-[75vw]" />
              ))}
            </FlexBox>
          ))}
        </div>
      </section>
    )
  }
}
